<cmps-dialog>
    <cmps-dialog-header [hasExpandAction]="true"></cmps-dialog-header>
    <cmps-dialog-body>
        <div class="onrv-body">
            <div
                cmpsObservationController
                [mode]="_ObservationControllerMode.REVIEW"
                [published]="_observation?.published"
                [allowedActions]="_allowedActions"
                [enabledActions]="_enabledActions"
                [pending]="
                    _observation?.pendingAny &&
                    !_observation?.pending?.config &&
                    !_observation?.pending?.reload
                "
                [dirty]="_observation?.dirty"
                (cancel)="_onCancel()"
                (share)="_observation?.share()"
                (edit)="_onEdit()"
                (delete)="_observation?.delete()"
                (publish)="_observation?.publish()"
                (save)="_observation?.save()"
            ></div>

            <div
                cmpsObservationNext
                storePathPrefix="observationReview"
                [mode]="
                    state?.inReview
                        ? _ObservationMode.REVIEW_READ_ONLY
                        : _ObservationMode.REVIEW_EDIT
                "
                [userId]="state?.selectedObservation?.performerId"
                [observationId]="state?.selectedObservation?.observationId"
                [focus]="_focus"
                [previousDisabled]="state?.observationIndex <= 0"
                (previous)="_onPrevious()"
                [nextDisabled]="
                    state?.observationIndex >= state?.observations?.length - 1
                "
                (next)="_onNext()"
                (allowedActionsChange)="_allowedActions = $event"
                (enabledActionsChange)="_enabledActions = $event"
                *ngIf="state?.selectedObservation"
            ></div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
